<template>
  <div class="tag-info">
    <div class="tag-info__inner">
      <h5 class="tag-info__title">Edit Polygon</h5>
      <div class="tag-info__col">
        <!-- Fill colour -->
        <div class="tag-info__block">
          <div class="inline-label">
            <label>Fill</label>
            <div class="colour-controls">
              <div
                class="btn-colour"
                :style="{ backgroundColor: value.fill }"
                @click="toggleColourWidget('fill')"
              ></div>
            </div>
          </div>

          <verte
            v-if="colourWidget === 'fill'"
            class="colour-picker"
            display="widget"
            picker="square"
            model="rgb"
            v-model="value.fill"
          />
        </div>

        <!-- Stroke colour -->
        <div class="tag-info__block">
          <div class="inline-label">
            <label>Stroke</label>
            <div class="colour-controls">
              <div
                class="btn-colour"
                :style="{ backgroundColor: value.stroke }"
                @click="toggleColourWidget('stroke')"
              ></div>
            </div>
          </div>

          <verte
            v-if="colourWidget === 'stroke'"
            class="colour-picker"
            display="widget"
            picker="square"
            model="rgb"
            v-model="value.stroke"
          />
        </div>

        <!-- Stroke width -->
        <div class="tag-info__block tag-info__block--inline">
          <label style="flex-shrink: 0; margin-right: 10px">Stroke Width</label>
          <input
            id="strokeWidth"
            class="form-control"
            type="number"
            max="20"
            min="0"
            v-model.number="value.strokeWidth"
          />
        </div>

        <!-- Drop shadow -->
        <div class="tag-info__block tag-info__block--inline">
          <label style="flex-shrink: 0; margin-right: 10px">Drop Shadow</label>
          <input
            class="form-control"
            type="checkbox"
            :checked="value.dropShadow"
            @change="value.dropShadow = $event.target.checked"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Verte from "verte";
import "verte/dist/verte.css";

export default {
  props: ["value"],

  components: {
    Verte,
  },

  data() {
    return {
      colourWidget: "",
    };
  },

  methods: {
    toggleColourWidget(key) {
      this.colourWidget = this.colourWidget === key ? "" : key;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/_mixins.scss";

.tag-info {
  background: rgba(255, 255, 255, 0.95);
  padding: 15px;
  pointer-events: all;
  width: 100%;
  height: 100%;
  transition: all 300ms ease-in-out;
  z-index: 100;

  &__inner {
    display: flex;
    flex-direction: column;
    height: 100%;
    overflow: auto;
    width: 100%;
  }

  &__title {
    font-size: 14px;
    font-weight: 600;
    margin: 0 0 10px;
  }

  &__col {
    display: flex;
    flex-direction: column;
    margin: 0 0 5px 0;
    width: 100%;
  }

  &__block {
    align-items: flex-start;
    display: flex;
    flex-direction: column;
    margin-bottom: 10px;

    label {
      font-size: 0.85em;
      margin: 0;
      text-transform: capitalize;
    }

    &--inline {
      align-items: center;
      flex-direction: row;
      justify-content: space-between;

      input {
        width: calc(100% - 20px);
      }
    }
  }
}

.inline-label {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  gap: 12px;

  label {
    margin: 0;
    font-size: 0.85em;
    flex: 1;
  }
}

.colour-controls {
  display: flex;
  align-items: center;
  gap: 8px;
}

.btn-colour {
  border: 1px solid #111;
  border-radius: 3px;
  width: 44px;
  height: 22px;
}

.colour-picker {
  margin-bottom: 10px;
  margin-top: 10px;
  width: 100%;
}
</style>
